import { BooleanInput, SelectInput, useRecordContext } from 'react-admin';
import { Typography } from '@mui/material';

export function CardScoringInputs() {
  const record = useRecordContext();
  return <>
    <Typography variant="subtitle1">Scoring review</Typography>
    <Typography color="text.secondary">
      {record?.scoringAxis ? `Reviewed dimension: ${record.scoringAxis}.` : 'Use context-only unless this card belongs to a supported scoring dimension.'}
      {' '}Forward means Yes aligns with the tendency; reverse means No aligns. Higher is not better.
      Changing wording or dimension resets scoring to context-only unless you explicitly review it again.
    </Typography>
    <SelectInput source="scoringDirection" label="Scoring direction" defaultValue="context_only" choices={[
      { id: 'context_only', name: 'Context only' }, { id: 'forward', name: 'Forward scored' }, { id: 'reverse', name: 'Reverse scored' },
    ]} />
    <BooleanInput source="reviewScoring" defaultValue={false} label="I reviewed the exact wording and its scoring direction" />
  </>;
}
